import * as Yup from 'yup';
import { isFuture } from 'date-fns';
import { APPLIED_TO_SERVICE_CENTER_OPTIONS } from '../../../containers/TravelCompensationContainer/options';
import accidentInfoSchema from '../accidentInfoSchema';
import accidentAddressSchema from '../accidentAddressSchema';

const newAccStreetSchema = Yup.object().shape({
  accStreet: Yup.string()
    .when('accCountry', {
      is: (accCountry) => accCountry && accCountry.label !== 'ARM',
      then: Yup.string().required('validationErrors.isRequired'),
      otherwise: Yup.string(),
    })
    .isCorrectLanguage(),
});

export const travelAccidentInfoSchema = Yup.object().shape({
  beforeSeeingDoctor: Yup.date()
    .nullable()
    .when('isAppliedToServiceCenter', {
      is: (isAppliedToServiceCenter) => (
        isAppliedToServiceCenter === APPLIED_TO_SERVICE_CENTER_OPTIONS[1].value),
      then: Yup.date()
        .test(
          'beforeSeeingDoctor',
          'validationErrors.accDateCantBeFuture',
          (value) => !isFuture(value),
        )
        .when(
          'startDate',
          (startDate, schem) => startDate && schem.min(startDate, 'validationErrors.notStartedPolicy'),
        )
        .when(
          'endDate',
          (endDate, schem) => endDate && schem.max(endDate, 'validationErrors.expiredPolicy'),
        )
        .required('validationErrors.isRequired'),
    }),
  afterSeeingDoctor: Yup.date()
    .nullable()
    .when('isAppliedToServiceCenter', {
      is: (isAppliedToServiceCenter) => (
        isAppliedToServiceCenter === APPLIED_TO_SERVICE_CENTER_OPTIONS[2].value),
      then: Yup.date()
        .test(
          'afterSeeingDoctor',
          'validationErrors.accDateCantBeFuture',
          (value) => !isFuture(value),
        )
        .when(
          'startDate',
          (startDate, schem) => startDate && schem.min(startDate, 'validationErrors.notStartedPolicy'),
        )
        .when(
          'endDate',
          (endDate, schem) => endDate && schem.max(endDate, 'validationErrors.expiredPolicy'),
        )
        .required('validationErrors.isRequired'),
    }),
}, [['beforeSeeingDoctor', 'afterSeeingDoctor']]).concat(accidentInfoSchema).concat(accidentAddressSchema.shape({
  accStreet: newAccStreetSchema.fields.accStreet, // Override accStreet validation
}));
